import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Flex } from '~/components/basic/containers';

const TitleContainer = styled(Flex)`
  margin: 0 auto 16px;
  font-weight: 600;
  font-size: 15px;
  vertical-align: baseline;
  justify-content: space-between;
  svg {
    width: 24px;
    height: 24px;
  }
`;

const TitleText = styled.div`
  display: flex;
  line-height: 24px;
  margin-left: 14px;
`;

const Title = ({ title, LogoIcon }) => (
  <TitleContainer>
    <LogoIcon />
    <TitleText>{title}</TitleText>
  </TitleContainer>
);

Title.propTypes = {
  title: PropTypes.string,
  LogoIcon: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]),
}

export default Title;